import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Attribute,
  AttributeOption,
  AttributesGroup,
  customAttributeOption,
} from '@app/shared/interfaces/Attribute';
import {
  AttributeValue,
  GenericOdataResponse,
  OdataResponse,
} from '@app/shared/interfaces/odata-response';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { ConnectionService } from '@app/shared/services/connection.service';
import { map, Observable } from 'rxjs';
import {
  AttributeDTO,
  ChangeGroupSort,
  CustomAttributeSet,
} from '../models/AttributeDTO';
import {
  DropDownOption,
  SmallDropDownOption,
} from '../models/GlobalInterfaces';
import { ProductAttribute } from '../models/ProductSubObjects';

@Injectable({
  providedIn: 'root',
})
export class AttributeService {
  private customProductUrl = `${AppConfigService.settings.apiUrl}CustomProduct/`;
  private customAttributeUrl = `${AppConfigService.settings.apiUrl}CustomAttribute/`;
  constructor(
    private http: HttpClient,
    private connection: ConnectionService
  ) {}
  getAttributeValues(
    ids: number[]
  ): Observable<GenericOdataResponse<ProductAttribute>> {
    const filters: string[] = [];
    ids.forEach((id) => {
      filters.push(`AttributeId eq ${id}`);
    });
    let filterStatment = filters.join(' or ');
    return this.http.get<GenericOdataResponse<ProductAttribute>>(
      `${AppConfigService.settings.dataApiUrl}ProductAttribute`,
      {
        params: { $filter: filterStatment },
      }
    );
  }
  getAttributeGroups(): Observable<GenericOdataResponse<AttributesGroup>> {
    return new Observable((observer) => {
      this.connection.query(
        `${AppConfigService.settings.dataApiUrl}Attribute?expand=AttributeGroup($select=Id,Name),AttributeSets($select=Id,Name)&$filter=AttributeSets/any()`,
        0,
        0,
        '',
        '',
        [],
        {},
        (res) => {
          observer.next(res);
          observer.unsubscribe();
        }
      );
    });
  }
  getEntityAttributes(
    entityId: number
  ): Observable<GenericOdataResponse<Attribute>> {
    return new Observable((observer) => {
      this.connection.get(
        `${AppConfigService.settings.dataApiUrl}Attribute?filter=RelatedObjectType eq ${entityId}`,
        (response) => observer.next(response)
      );
    });
  }

    getGroupsOfAttributeSet(id: number, languageId?: number) {
    return this.http.get(
      `${this.customAttributeUrl}GetGroupsOfAttributeSet/${id}?languageId=${languageId ?? 0}`
    );
}


  getAttributeSets(): Observable<CustomAttributeSet[]> {
    return this.http.get<CustomAttributeSet[]>(
      `${this.customAttributeUrl}get-attribute-sets`
    );
  }
  getConfigurableAttributes(
    attributeSetId: number
  ): Observable<DropDownOption[]> {
    return this.http
      .get<DropDownOption[]>(
        this.customProductUrl +
          `ConfigurableAttributes?attributeSetId=${attributeSetId}`
      )
      .pipe(
        map((response: any[]) => {
          return response.map((x) => {
            return { Code: x.code, Label: x.label };
          });
        })
      );
  }
  saveAttributeValues(values: AttributeValue[]) {
    return this.http.post(
      `${AppConfigService.settings.apiUrl}CustomProductAttribute/PostAttributeValues`,
      values
    );
  }

  getAttributeOptions(ids: string[]) {
    return this.http.post(
      `${this.customAttributeUrl}GetAttributesOptions`,
      ids
    );
  }
  postAttributeOption(option: AttributeOption) {
    return this.http.post(
      `${AppConfigService.settings.dataApiUrl}AttributeOption`,
      option
    );
  }
  getGroupAttributes(groupId: number) {
    return this.http.get(
      `${this.customAttributeUrl}GroupAttributes/${groupId}`
    );
  }

  getRelationAttributeOptions(objectType: number, filterStatement?: string) {
    return this.http.get(
      `${
        AppConfigService.settings.apiUrl
      }CustomAttribute/RelationAttributeOptions/${objectType}?filterStatement=${
        filterStatement == null || filterStatement == ''
          ? 'null'
          : filterStatement
      }`
    );
  }

  dropDownAttributes() {
    return this.http.get(`${this.customAttributeUrl}DropDownAttributes`);
  }
  changeGroupOrder(params: ChangeGroupSort) {
    return this.http.put(
      `${AppConfigService.settings.apiUrl}CustomAttribute/change-group-sort`,
      params
    );
  }
  getChildAttributes(attributeId: number): Observable<OdataResponse> {
    return new Observable((obs) => {
      this.connection.get(
        `${AppConfigService.settings.dataApiUrl}Attribute?filter=ParentAttributeId eq ${attributeId}`,
        (response) => {
          obs.next(response);
        }
      );
    });
  }
  postChilAttributes(parentId: number, attriubtes: AttributeDTO[]) {
    return this.http.post(
      `${this.customAttributeUrl}PostChildAttributes/${parentId}`,
      attriubtes
    );
  }

  getAllChildAttributes(): Observable<OdataResponse> {
    return new Observable((obs) => {
      this.connection.get(
        `${AppConfigService.settings.dataApiUrl}Attribute?filter=ParentAttributeId ne null`,
        (response) => {
          obs.next(response);
        }
      );
    });
  }

  getAttributesCodeName(): Observable<SmallDropDownOption[]> {
    return this.http.get<SmallDropDownOption[]>(
      `${this.customAttributeUrl}attributes-code-name`
    );
  }

  modifyGroupName(id: number, group: any) {
    return this.http.put(
      `${this.customAttributeUrl}modify-group-name/${id}`,
      group
    );
  }
  deleteAttributeGroup(groupId: number) {
    return this.http.delete(
      `${AppConfigService.settings.dataApiUrl}AttributeGroup(${groupId})`
    );
  }


  getAttributesBySetId(attributeSetId: number): Observable<GenericOdataResponse<Attribute>> {
    const url = `${AppConfigService.settings.dataApiUrl}AttributeSet/${attributeSetId}`;
    return this.http.get<GenericOdataResponse<Attribute>>(url);
  }
  getAllAtribute(){
  //&expand=AttributeValueAttributes 
  return this.http.get(`${AppConfigService.settings.dataApiUrl}Attribute?expand=AttributeOptions`);
}
}
